"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSuggestedAction = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useDisabled3 = _interopRequireDefault(require("../hooks/useDisabled"));

var _useFocusSendBox = _interopRequireDefault(require("../hooks/useFocusSendBox"));

var _usePerformCardAction = _interopRequireDefault(require("../hooks/usePerformCardAction"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

var _useSuggestedActions3 = _interopRequireDefault(require("../hooks/useSuggestedActions"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SUGGESTED_ACTION_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column',
  whiteSpace: 'initial',
  '& > button': {
    display: 'flex',
    overflow: 'hidden'
  }
});

var connectSuggestedAction = function connectSuggestedAction() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var clearSuggestedActions = _ref.clearSuggestedActions,
        disabled = _ref.disabled,
        language = _ref.language,
        onCardAction = _ref.onCardAction;
    var displayText = _ref2.displayText,
        text = _ref2.text,
        type = _ref2.type,
        value = _ref2.value;
    return {
      click: function click() {
        onCardAction({
          displayText: displayText,
          text: text,
          type: type,
          value: value
        });
        type === 'openUrl' && clearSuggestedActions();
      },
      disabled: disabled,
      language: language
    };
  }].concat(selectors));
};

exports.connectSuggestedAction = connectSuggestedAction;

var SuggestedAction = function SuggestedAction(_ref3) {
  var ariaHidden = _ref3['aria-hidden'],
      buttonText = _ref3.buttonText,
      displayText = _ref3.displayText,
      image = _ref3.image,
      text = _ref3.text,
      type = _ref3.type,
      value = _ref3.value;

  var _useSuggestedActions = (0, _useSuggestedActions3.default)(),
      _useSuggestedActions2 = _slicedToArray(_useSuggestedActions, 2),
      _ = _useSuggestedActions2[0],
      setSuggestedActions = _useSuggestedActions2[1];

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      suggestedActionStyleSet = _useStyleSet2[0].suggestedAction;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var _useDisabled = (0, _useDisabled3.default)(),
      _useDisabled2 = _slicedToArray(_useDisabled, 1),
      disabled = _useDisabled2[0];

  var focusSendBox = (0, _useFocusSendBox.default)();
  var performCardAction = (0, _usePerformCardAction.default)();
  var handleClick = (0, _react.useCallback)(function () {
    performCardAction({
      displayText: displayText,
      text: text,
      type: type,
      value: value
    });
    type === 'openUrl' && setSuggestedActions([]);
    focusSendBox();
  }, [displayText, focusSendBox, performCardAction, setSuggestedActions, text, type, value]);
  return _react.default.createElement("div", {
    "aria-hidden": ariaHidden,
    className: (0, _classnames.default)(suggestedActionStyleSet + '', SUGGESTED_ACTION_CSS + '')
  }, _react.default.createElement("button", {
    disabled: disabled,
    onClick: handleClick,
    type: "button"
  }, image && _react.default.createElement("img", {
    className: (0, _classnames.default)(direction === 'rtl' && 'webchat__suggestedactions--rtl'),
    src: image
  }), _react.default.createElement("nobr", null, buttonText)));
};

SuggestedAction.defaultProps = {
  'aria-hidden': false,
  displayText: '',
  image: '',
  text: '',
  type: '',
  value: undefined
};
SuggestedAction.propTypes = {
  'aria-hidden': _propTypes.default.bool,
  buttonText: _propTypes.default.string.isRequired,
  displayText: _propTypes.default.string,
  image: _propTypes.default.string,
  text: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.any
};
var _default = SuggestedAction;
exports.default = _default;